// The reply box on a notice contact (2026-10-12; prod 6355963, "Refund from
// 1A Site Automation", showed Send New Outbound Email with To =
// service@1aauto.com). A Site Automation failure notice, or any system notice
// (From our own mailbox, every To ours), is not a message from the customer:
// its headers name our own mailbox. So its reply goes to the ORDER's
// customer, and is a new outbound email, never a reply into the notice.
//
//   - the To is the order enrichment's customer email (the order summary's,
//     then the suggestion's server-resolved one), NEVER the sender, the
//     Reply-To, the participant id, or any internal address;
//   - with no customer email on the order the To stays empty and Send is
//     disabled with NO_ORDER_EMAIL_REASON (the server refuses too:
//     send-approved-reply.js).
//
// The internal-address rule mirrors server/src/channels/m365/internal-address.js
// (every CXHub mailbox, alias and send identity is on one of these domains).

export const INTERNAL_DOMAINS = Object.freeze(['1aauto.com', 'am-autoparts.com', 'trqautoparts.com'])
export const NO_ORDER_EMAIL_REASON = 'No customer email on the order'

// An address on one of our company domains or their subdomains.
export function isInternalAddress(address) {
  const a = String(address ?? '').trim().toLowerCase()
  const at = a.lastIndexOf('@')
  if (at < 1) return false
  const domain = a.slice(at + 1)
  return INTERNAL_DOMAINS.some((d) => domain === d || domain.endsWith(`.${d}`))
}

// A Site Automation failure notice, by its parsed metadata (either source
// spelling the server has stored).
export function isSiteAutomationInbound(inbound) {
  const source = inbound?.metadata?.automatedReturnNotice?.source
  return source === 'site_automation' || source === 'am_site_automation'
}

// A notice whose To comes from the order only: a Site Automation notice, or
// any system notice.
// A task contact's email response (Tasks Phase 1, 2026-10-13) goes to the
// order's customer the same way.
export function isOrderOnlyToNotice(inbound) {
  return isSiteAutomationInbound(inbound) || ['system_notice', 'task'].includes(inbound?.metadata?.messageKind)
}

// The To for such a notice: the first non-internal of the order summary's
// customer email and the suggestion's; '' when neither is usable.
export function noticeSeedTo({ orderSummaryCustomerEmail = null, suggestionCustomerEmail = null } = {}) {
  for (const candidate of [orderSummaryCustomerEmail, suggestionCustomerEmail]) {
    const value = String(candidate ?? '').trim()
    if (value && !isInternalAddress(value)) return value
  }
  return ''
}

// A late-resolving order email fills an empty To (or one still holding an
// internal address) and never overwrites a To the agent typed.
export function fillLateTo(prev, candidate) {
  const current = String(prev ?? '').trim()
  if (!candidate) return prev
  return !current || isInternalAddress(current) ? candidate : prev
}

// Why Send is disabled on such a notice, or null.
export function noticeToBlockReason({ inbound, draftTo, channel }) {
  if (channel !== 'm365_email' || !isOrderOnlyToNotice(inbound)) return null
  return String(draftTo ?? '').trim() ? null : NO_ORDER_EMAIL_REASON
}
